import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { Box, Button, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

const AgentCard = ({ agent, canMutate, onSelect }) => {
  const hasAgent = Boolean(agent?.name);

  return (
    <Button
      onClick={onSelect}
      disabled={!canMutate}
      sx={{
        'p': 0,
        'minHeight': 72,
        'justifyContent': 'stretch',
        'borderRadius': '12px',
        'overflow': 'hidden',
        'alignSelf': 'center',
        'width': '100%',
        'maxWidth': 280,
        'textTransform': 'none',
        'border': '1px solid rgba(0,0,0,0.08)',
        'boxShadow': '0 1px 2px rgba(0,0,0,0.06)',
        'backgroundColor': '#fff',
        'color': 'inherit',
        '&:hover': {
          backgroundColor: theme =>
            alpha(theme.palette.brand.blue.secondary, 0.06),
          borderColor: theme => alpha(theme.palette.brand.blue.primary, 0.35),
        },
        '&.Mui-disabled': {
          backgroundColor: '#fff',
          borderColor: 'rgba(0,0,0,0.08)',
        },
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 1.5,
          py: 1.25,
        }}
      >
        <Box
          sx={{
            width: 44,
            height: 44,
            flexShrink: 0,
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: hasAgent ? '#fff' : 'brand.grey.ternary',
            backgroundColor: theme =>
              hasAgent
                ? theme.palette.brand.blue.primary
                : alpha(theme.palette.brand.grey.quaternary, 0.55),
          }}
        >
          <PhoneAndroidIcon sx={{ fontSize: 22 }} />
        </Box>

        <Box sx={{ flex: 1, minWidth: 0, textAlign: 'right' }}>
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 600,
              color: 'brand.grey.ternary',
              mb: 0.25,
            }}
          >
            ایجنت
          </Typography>
          <Typography
            sx={{
              fontSize: 14,
              fontWeight: 700,
              color: hasAgent ? 'brand.blue.primary' : 'brand.grey.secondary',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {agent?.name || 'انتخاب کاربر'}
          </Typography>
        </Box>
      </Box>
    </Button>
  );
};

export default AgentCard;
